import { ChatNotificationPreferences } from './settingsTypes';

export function buildChatPrefsPayload(
  chatPrefs: ChatNotificationPreferences,
  overrides: Partial<{
    emailEnabled: boolean;
    googleChatEnabled: boolean;
    teamsChatEnabled: boolean;
    slackChatEnabled: boolean;
  }> = {},
) {
  return {
    emailEnabled: overrides.emailEnabled ?? chatPrefs.emailEnabled,
    emailTiming: chatPrefs.emailTiming,
    emailUnansweredMinutes: chatPrefs.emailUnansweredMinutes,
    googleChatEnabled: overrides.googleChatEnabled ?? chatPrefs.googleChatEnabled,
    googleChatTiming: chatPrefs.googleChatTiming,
    googleChatUnansweredMinutes: chatPrefs.googleChatUnansweredMinutes,
    teamsChatEnabled: overrides.teamsChatEnabled ?? chatPrefs.teamsChatEnabled,
    teamsChatTiming: chatPrefs.teamsChatTiming,
    teamsChatUnansweredMinutes: chatPrefs.teamsChatUnansweredMinutes,
    slackChatEnabled: overrides.slackChatEnabled ?? chatPrefs.slackChatEnabled,
    slackChatTiming: chatPrefs.slackChatTiming,
    slackChatUnansweredMinutes: chatPrefs.slackChatUnansweredMinutes,
  };
}

export function mapChatPrefsFromResponse(
  data: ChatNotificationPreferences,
): ChatNotificationPreferences {
  return {
    emailEnabled: data.emailEnabled,
    emailTiming: data.emailTiming,
    emailUnansweredMinutes: data.emailUnansweredMinutes,
    googleChatEnabled: data.googleChatEnabled,
    googleChatTiming: data.googleChatTiming,
    googleChatUnansweredMinutes: data.googleChatUnansweredMinutes,
    googleChatConnected: data.googleChatConnected,
    googleUserEmail: data.googleUserEmail,
    teamsChatEnabled: data.teamsChatEnabled,
    teamsChatTiming: data.teamsChatTiming,
    teamsChatUnansweredMinutes: data.teamsChatUnansweredMinutes,
    teamsChatConnected: data.teamsChatConnected,
    teamsUserEmail: data.teamsUserEmail,
    slackChatEnabled: data.slackChatEnabled,
    slackChatTiming: data.slackChatTiming,
    slackChatUnansweredMinutes: data.slackChatUnansweredMinutes,
    slackChatConnected: data.slackChatConnected,
    slackUserEmail: data.slackUserEmail,
  };
}
